export default __webpack_public_path__ + "static/media/pricing-4.185185fd.svg";